import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export const Unauthorized: React.FC = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: { pathname?: string } })?.from?.pathname || '/';

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 4 }}>
      <Paper
        elevation={0}
        sx={{
          p: 6,
          textAlign: 'center',
          border: 1,
          borderColor: 'divider',
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            bgcolor: 'error.light',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
          }}
        >
          <LockIcon sx={{ fontSize: 40, color: 'error.main' }} />
        </Box>

        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
          {t('unauthorized.title', 'Access Denied')}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 500, mx: 'auto' }}>
          {t(
            'unauthorized.message',
            "You don't have permission to access this page. Please contact your administrator if you believe this is an error."
          )}
        </Typography>

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 4 }}>
          {t('unauthorized.attempted_path', 'Attempted to access: {{path}}', { path: from })}
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button variant="outlined" onClick={handleGoBack}>
            {t('unauthorized.go_back', 'Go Back')}
          </Button>
          <Button variant="contained" onClick={handleGoHome}>
            {t('unauthorized.go_home', 'Go Home')}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};
